
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stock_is_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stock_group"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"stock_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_tel"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stock_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_a"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_b"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_c"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_d"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_s"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_hra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_hrb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_hrc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_hrd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_price_z"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock_group"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"_type_stock_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"our_company"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stock_groups"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stock_groups"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":603}};
    doc.loc.source = {"body":"# @format\nquery GetPriceList($company_id: String!) {\n\tstock(\n\t\twhere: { company_id: { _eq: $company_id }, stock_is_active: { _eq: true } }\n\t\torder_by: { stock_group: asc, stock_id: asc }\n\t) {\n\t\tcompany {\n\t\t\tcompany_email\n\t\t\tcompany_tel\n\t\t}\n\t\tstock_id\n\t\tstock_name\n\t\tstock_unit\n\t\tstock_price\n\t\tstock_price_a\n\t\tstock_price_b\n\t\tstock_price_c\n\t\tstock_price_d\n\t\tstock_price_s\n\t\tstock_price_hra\n\t\tstock_price_hrb\n\t\tstock_price_hrc\n\t\tstock_price_hrd\n\t\tstock_price_z\n\t\tstock_group\n\t}\n\t_type_stock_groups(\n\t\twhere: { our_company: { _eq: $company_id } }\n\t\torder_by: { stock_groups: asc }\n\t) {\n\t\tstock_groups\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetPriceList"] = oneQuery(doc, "GetPriceList");
        
